<template>
  <div class="goods-but">
    <span>{{ name }}</span>
    <el-button type="primary" @click="onProduct" :disabled="disabled">选择课程</el-button>
  </div>
  <el-dialog v-model="formDrawerVisible" :width="800" title="课程列表">
    <el-table height="540px" border :data="list" v-loading="loading" empty-text="暂无数据" style="width: 100%">
      <el-table-column prop="id" label="套餐ID" />
      <el-table-column prop="package_name" min-width="200" label="套餐名称" />
      <el-table-column prop="num" label="数量" />
      <el-table-column prop="now_price" label="现价" />
      <el-table-column prop="old_price" label="原价" />
      <el-table-column label="操作" min-width="60">
        <template #default="scope">
          <div class="list-but">
            <el-button type="primary" @click="choice(scope.row)">选择</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
import { packageList } from '@/apis/common'

export default {
  data() {
    return {
      info: JSON.parse(sessionStorage.getItem('user')) || {},
      formDrawerVisible: false,
      loading: false,
      list: [],
      name: '',
      disabled: true
    }
  },
  props: {
    data: {
      type: String,
      default: ''
    }
  },
  watch: {
    data: {
      handler(val) {
        this.disabled = val === ''
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    choice(e) {
      this.name = e.package_name
      this.$emit('choice', e)
      this.formDrawerVisible = false
    },
    onProduct() {
      this.formDrawerVisible = true
      this.getSchoolGoodsList()
    },
    getSchoolGoodsList() {
      this.loading = true
      packageList({
        admin_id: this.info.id,
        school_id: this.info.agency_school_id,
        course_name: this.data,
        page: 1,
        pagesize: 40,
        is_all: 1,
        status: 1
      }).then(res => {
        this.list = res.data.data.list
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>
.goods-but > span {
    width: calc(100% - 80px);
    display: inline-block;
}
</style>
